import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

const { PlusGoodsWeb } = UrlConfig

// 查询商品-品类管理树形列表
export const getGoodsCategoryTreeList = async data => {
  return request(PlusGoodsWeb.GetGoodsCategoryTreeList, {
    method: METHODS.POST,
    data,
  })
}
// 商品-品类管理保存
export const goodsCategorySave = async data => {
  return request(PlusGoodsWeb.GoodsCategorySave, {
    method: METHODS.POST,
    data,
  })
}
// 商品-品类管理修改
export const goodsCategoryUpdateById = async data => {
  return request(PlusGoodsWeb.GoodsCategoryUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 商品-品类管理修改状态
export const goodsCategoryUpdateState = async data => {
  return request(PlusGoodsWeb.GoodsCategoryUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 商品-品类管理删除
export const goodsCategoryDelete = async id => {
  return request(PlusGoodsWeb.GoodsCategoryDelete + id, {
    method: METHODS.DELETE,
  })
}

// 查询商品-销售类目管理树形列表
export const getGoodsSaleCategoryTreeList = async data => {
  return request(PlusGoodsWeb.GetGoodsSaleCategoryTreeList, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理保存
export const goodsSaleCategorySave = async data => {
  return request(PlusGoodsWeb.GoodsSaleCategorySave, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理修改
export const goodsSaleCategoryUpdateById = async data => {
  return request(PlusGoodsWeb.GoodsSaleCategoryUpdateById, {
    method: METHODS.POST,
    data,
  })
}

// 商品-品类管理修改状态
export const goodsSaleCategoryUpdateState = async data => {
  return request(PlusGoodsWeb.GoodsSaleCategoryUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理删除
export const goodsSaleCategoryDelete = async id => {
  return request(PlusGoodsWeb.GoodsSaleCategoryDelete + id, {
    method: METHODS.DELETE,
  })
}

// 查询商品-销售类目管理-类目介绍
export const getGoodsSaleCategoryDescList = async data => {
  return request(PlusGoodsWeb.GetGoodsSaleCategoryDescList, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理-类目介绍-保存
export const goodsSaleCategoryDescSave = async data => {
  return request(PlusGoodsWeb.GoodsSaleCategoryDescSave, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理-类目介绍-修改
export const goodsSaleCategoryDescUpdateById = async data => {
  return request(PlusGoodsWeb.GoodsSaleCategoryDescUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 商品-销售类目管理-类目介绍-删除
export const goodsSaleCategoryDescDelete = async id => {
  return request(PlusGoodsWeb.GoodsSaleCategoryDescDelete + id, {
    method: METHODS.DELETE,
  })
}

// 查询商品管理
export const getGoodsPage = async options => {
  return request(PlusGoodsWeb.GetGoodsManagementPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 商品管理修改
export const goodsManagementUpdateById = async data => {
  return request(PlusGoodsWeb.GoodsManagementUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理修改状态
export const goodsManagementUpdateState = async data => {
  return request(PlusGoodsWeb.GoodsManagementUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理删除
export const goodsManagementDelete = async id => {
  return request(PlusGoodsWeb.GoodsManagementDelete, {
    method: METHODS.POST,
    data: id,
  })
}
// 商品管理 - 产品分页（转化为商品所用字段）
export const getGoodsManagementDealProductPage = async options => {
  return request(PlusGoodsWeb.GetGoodsManagementDealProductPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 商品管理 - 详情
export const getGoodsManagementInfo = async params => {
  return request(PlusGoodsWeb.GetGoodsManagementInfo, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 - 清除缓存
export const goodsManagementCleanCache = async params => {
  return request(PlusGoodsWeb.GoodsManagementCleanCache, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 - 复制
export const goodsManagementCopyInit = async data => {
  return request(PlusGoodsWeb.GoodsManagementCopyInit, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 - 上下架 - 切换保存销售类目
export const goodsManagementSaveSaleCat = async params => {
  return request(PlusGoodsWeb.GoodsManagementSaveSaleCat, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 - 下一步保存
export const goodsManagementSaveEditInfo = async data => {
  return request(PlusGoodsWeb.GoodsManagementSaveEditInfo, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 -  第二步 销售配置
export const goodsManagementGetSaleConfigByParam = async data => {
  return request(PlusGoodsWeb.GoodsManagementGetSaleConfigByParam, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 -  第二步 销售配置 保存
export const goodsManagementGoodsSaleConfSave = async data => {
  return request(PlusGoodsWeb.GoodsManagementGoodsSaleConfSave, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 -  第三步 合同配置
export const goodsManagementGetQuotaConfPage = async options => {
  return request(PlusGoodsWeb.GoodsManagementGetQuotaConfPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 商品管理 -  第三步 合同配置 保存
export const goodsManagementGoodsQuotaConfSave = async data => {
  return request(PlusGoodsWeb.GoodsManagementGoodsQuotaConfSave, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 -  第三步 合同配置 删除
export const goodsManagementGetQuotaConfDelete = async params => {
  return request(PlusGoodsWeb.GoodsManagementGetQuotaConfDelete, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 -  第三步 合同配置 报价类型
export const goodsManagementGetPrdArgManageListByGoodsId = async params => {
  return request(PlusGoodsWeb.GoodsManagementGetPrdArgManageListByGoodsId, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 -  第三步 合同配置 报价合同配置（与报价类型联动）
export const goodsManagementGetQuotaContractInfoPage = async options => {
  return request(PlusGoodsWeb.GoodsManagementGetQuotaContractInfoPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 商品管理 -  第三步 合同配置 下一步保存
export const goodsManagementGoodsQuotaConfNextSave = async options => {
  return request(PlusGoodsWeb.GoodsManagementGoodsQuotaConfNextSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 商品管理 -  第四步 收款规则配置
export const goodsManagementGoodsPayeeConfPage = async options => {
  return request(PlusGoodsWeb.GoodsManagementGoodsPayeeConfPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 商品管理 -  第四步 收款规则配置 保存
export const goodsManagementGoodsPayeeConfSave = async data => {
  return request(PlusGoodsWeb.GoodsManagementGoodsPayeeConfSave, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 -  第四步 收款规则配置 删除
export const goodsManagementGoodsPayeeConfDeleteInfoById = async params => {
  return request(PlusGoodsWeb.GoodsManagementGoodsPayeeConfDeleteInfoById, {
    method: METHODS.GET,
    params,
  })
}
// 商品管理 -  提交保存
export const goodsManagementSubmit = async id => {
  return request(PlusGoodsWeb.GoodsManagementSubmit, {
    method: METHODS.GET,
    params: { id },
  })
}
// 商品管理 - 上下架
export const goodsManagementGoodsSkuPage = async options => {
  return request(PlusGoodsWeb.GoodsManagementGoodsSkuPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 商品管理 - 上下架- 保存
export const goodsManagementGoodsSkuSave = async data => {
  return request(PlusGoodsWeb.GoodsManagementGoodsSkuSave, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 - 上下架- 保存销售类目
export const goodsManagementGoodsSkuSaveSaleCate = async data => {
  return request(PlusGoodsWeb.GoodsManagementGoodsSkuSaveSaleCate, {
    method: METHODS.POST,
    data,
  })
}
// 商品管理 - 批量上下架
export const goodsManagementBatchChangeState = async data => {
  return request(PlusGoodsWeb.GoodsManagementBatchChangeState, {
    method: METHODS.POST,
    data,
  })
}

// 查询合同模板列表(分页)
export const getContractTemplateList = async data => {
  return request(
    `${PlusGoodsWeb.GetContractTemplateList}?pageId=${data.pageId}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 查询合同模板列表(全部)
export const getContractTemplateListAll = async data => {
  return request(`${PlusGoodsWeb.GetContractTemplateListAll}`, {
    method: METHODS.POST,
    data,
  })
}
// 新增合同模板
export const addNewContractTemplate = async data => {
  return request(PlusGoodsWeb.AddNewContractTemplate, {
    method: METHODS.POST,
    data,
  })
}
// 编辑合同模板
export const uploadContractTemplate = async data => {
  return request(PlusGoodsWeb.UploadContractTemplate, {
    method: METHODS.POST,
    data,
  })
}
// 查询合同模板详情
export const queryContractTemplateDetail = async data => {
  return request(PlusGoodsWeb.QueryContractTemplate, {
    method: METHODS.POST,
    data,
  })
}
// 合同模板预览接口
export const previewPrintTemplate = async data => {
  return request(PlusGoodsWeb.PreviewPrintTemplate, {
    method: METHODS.POST,
    data,
  })
}
// 删除查询合同模板
export const deleteContractTemplate = async id => {
  return request(`${PlusGoodsWeb.DeleteContractTemplate}/${id}`, {
    method: METHODS.DELETE,
  })
}
// 合同模板修改状态
export const changeContractTemplateStatus = async data => {
  return request(`${PlusGoodsWeb.ChangeContractTemplateStatus}/${data.id}?enable=${data.enable}`, {
    method: METHODS.POST,
  })
}
// 新增合同扩展字段
export const addNewContractTemplateExtend = async data => {
  return request(PlusGoodsWeb.AddContractTemplateExtend, {
    method: METHODS.POST,
    data,
  })
}
// 合同扩展字段列表
export const getContractTemplateExtendList = async data => {
  return request(
    `${PlusGoodsWeb.GetContractTemplateExtendList}?pageId=${data.pageId}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 合同扩展字段编辑
export const updateNewContractTemplateExtend = async data => {
  return request(PlusGoodsWeb.UpdateContractTemplateExtend, {
    method: METHODS.POST,
    data,
  })
}
// 删除合同扩展字段
export const deleteNewContractTemplateExtend = async id => {
  return request(`${PlusGoodsWeb.DeleteContractTemplateExtend}/${id}`, {
    method: METHODS.DELETE,
  })
}
// 过滤类型枚举
export const getFilterTypeEnum = async () => {
  return request(PlusGoodsWeb.FilterTypeEnum, {
    method: METHODS.GET,
  })
}

// 纸张方向枚举
export const getPrintPaperDirectionEnum = async () => {
  return request(PlusGoodsWeb.PrintPaperDirectionEnum, {
    method: METHODS.GET,
  })
}
// 扩展字段分类
export const getExtensionItemTypeEnum = async () => {
  return request(PlusGoodsWeb.ExtensionItemTypeEnum, {
    method: METHODS.GET,
  })
}

// 扩展字段类型
export const getExtensionFieldTypeEnum = async () => {
  return request(PlusGoodsWeb.ExtensionFieldTypeEnum, {
    method: METHODS.GET,
  })
}
// 查询合同配置列表(分页)
export const getContractInfoList = async data => {
  return request(
    `${PlusGoodsWeb.GetContractInfoList}?pageId=${data.pageId}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 查询合同配置详情
export const queryContractInfoDetail = async id => {
  return request(`${PlusGoodsWeb.QueryContractInfo}/${id}`, {
    method: METHODS.GET,
  })
}
// 新增报价合同配置
export const addNewPriceContract = async data => {
  return request(PlusGoodsWeb.AddNewPriceContract, {
    method: METHODS.POST,
    data,
  })
}
// 编辑报价合同配置
export const uploadContractInfo = async data => {
  return request(PlusGoodsWeb.UploadContractInfo, {
    method: METHODS.POST,
    data,
  })
}
// 删除报价合同配置
export const deletePriceContract = async id => {
  return request(`${PlusGoodsWeb.DeletePriceContract}/${id}`, {
    method: METHODS.DELETE,
  })
}
// 合同模板修改状态
export const changeContractInfoStatus = async data => {
  return request(`${PlusGoodsWeb.ChangeContractInfoStatus}/${data.id}?enable=${data.enable}`, {
    method: METHODS.POST,
  })
}
// 报价类型枚举
export const getBudgetTypeEnum = async () => {
  return request(PlusGoodsWeb.GetBudgetTypeEnum, {
    method: METHODS.GET,
  })
}
// 报价类型枚举
export const getBudgetTypeEnumNew = async () => {
  return request(PlusGoodsWeb.GetBudgetTypeEnumNew, {
    method: METHODS.GET,
  })
}

// 合同类型枚举
export const getContractTypeEnum = async () => {
  return request(PlusGoodsWeb.GetContractTypeEnum, {
    method: METHODS.GET,
  })
}

// 变量类型枚举
export const companyPrintVarTypeEnum = async () => {
  return request(PlusGoodsWeb.CompanyPrintVarTypeEnum, {
    method: METHODS.GET,
  })
}

// 新增分公司打印变量
export const companyPrintVarConfig = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.CompanyPrintVarConfig, {
    method: METHODS.POST,
    data,
  })
}

// 编辑分公司打印变量
export const updateCompanyPrintVarConfig = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.UpdateCompanyPrintVarConfig, {
    method: METHODS.POST,
    data,
  })
}

// 删除分公司打印变量
export const deleteCompanyPrintVarConfig = async (id: any) => {
  return await request(`${UrlConfig.PlusGoodsWeb.CompanyPrintVarConfig}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 分页查询分公司打印变量
export const getCompanyPrintVarConfig = async (options: any) => {
  return await request(UrlConfig.PlusGoodsWeb.GetCompanyPrintVarConfig, {
    method: METHODS.POST,
    ...options,
  })
}

// 产品发布
export const pushGoodsInitInfoByProdId = async id => {
  return request(PlusGoodsWeb.PushGoodsInitInfoByProdId + '?productId=' + id, {
    method: METHODS.GET,
  })
}

// 查合同列表
export const getBudgetPrintInfoMap = async (data: any) => {
  return await request(UrlConfig.PlusTradeWeb.GetBudgetPrintInfoMap, {
    method: METHODS.POST,
    data,
  })
}

// 发起线下电子合同
export const startOfflineContract = async (data: any) => {
  return await request(UrlConfig.PlusTradeWeb.StartOfflineContract, {
    method: METHODS.POST,
    data,
  })
}

// 提交签约
export const SubmitOfflineElec = async (data: any) => {
  return await request(UrlConfig.PlusTradeWeb.SubmitOfflineElec, {
    method: METHODS.POST,
    data,
  })
}

// C端销售类目接口
export const getCategoryByParentId = async (id: any) => {
  return await request(`${UrlConfig.PlusGoodsWeb.GetCategoryByParentId}/${id}`, {
    method: METHODS.POST,
    data: {},
  })
}

// 贷款机构列表
export const queryLoanOrgList = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.queryLoanOrgList, {
    method: METHODS.POST,
    data,
  })
}

// 是否展示贷款机构列表
export const hasLoanOrg = async (data: any) => {
  return await request(
    `${UrlConfig.PlusGoodsWeb.hasLoanOrg}?quoteId=${data.quoteId}&quoteContractId=${data.quoteContractId}`,
    {
      method: METHODS.POST,
    }
  )
}

// 保存贴息
export const saveQuoteDiscountBus = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.saveQuoteDiscountBus, {
    method: METHODS.POST,
    data,
  })
}

// 获取商品列表
export const selectForOnlineShop = async (options: any) => {
  return await request(UrlConfig.PlusGoodsWeb.SelectForOnlineShop, {
    method: METHODS.POST,
    ...options,
  })
}

// 获取订单列表
export const getOrderCustomerPage = async (options: any) => {
  return await request(UrlConfig.PlusGoodsWeb.GetOrderCustomerPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 获取收款列表
export const getResponseListForCustomer = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.GetResponseListForCustomer, {
    method: METHODS.POST,
    data,
  })
}
// 签约模板列表
export const getSignTemplateList = async (options: any) => {
  return await request(UrlConfig.PlusGoodsWeb.getSignTemplateList, {
    method: METHODS.POST,
    ...options,
  })
}

// 签约模板详情列表
export const getSignTemplateDetailList = async (options: any) => {
  return await request(UrlConfig.PlusGoodsWeb.getSignTemplateDetailList, {
    method: METHODS.POST,
    ...options,
  })
}

// 新增签约模板
export const addSignTemplate = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.AddSignTemplate, {
    method: METHODS.POST,
    data,
  })
}

// 修改签约模板
export const updateSignTemplate = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.updateSignTemplate, {
    method: METHODS.POST,
    data,
  })
}

// 删除签约模板
export const deleteSignTemplate = async (id: any) => {
  return await request(`${UrlConfig.PlusGoodsWeb.deleteSignTemplate}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 新增签约模板配置
export const addSignTemplateDetail = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.addSignTemplateDetail, {
    method: METHODS.POST,
    data,
  })
}

// 修改签约模板配置
export const updateSignTemplateDetail = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.updateSignTemplateDetail, {
    method: METHODS.POST,
    data,
  })
}

// 删除签约模板配置
export const deleteSignTemplateDetail = async (id: any) => {
  return await request(`${UrlConfig.PlusGoodsWeb.deleteSignTemplateDetail}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 导入签约模板配置
export const importSignTemplate = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.importSignTemplate, {
    method: METHODS.POST,
    data,
  })
}

// 批量删除签约模板配置
export const deleteTemplateDetailBatch = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.deleteTemplateDetailBatch, {
    method: METHODS.DELETE,
    data,
  })
}
// 批量新增品牌过滤配置接口
export const BaWBatchAddConfigs = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.BaWBatchAddConfigs, {
    method: METHODS.POST,
    data,
  })
}
// 编辑品牌过滤配置接口
export const BaWUpdateById = async (data: any) => {
  return await request(UrlConfig.PlusGoodsWeb.BaWUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 分页品牌过滤配置查询
export const BaWPage = async (data: any) => {
  return await request(
    UrlConfig.PlusGoodsWeb.BaWPage + `?pageId=${data.current}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 分页品牌过滤配置 - 删除
export const BaWPageDelete = async data => {
  return request(UrlConfig.PlusGoodsWeb.BaWPageDelete, {
    method: METHODS.DELETE,
    data,
  })
}
